import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { EntitaAnagrafeVO } from "@app/shared/vo/gescor/entita-anagrafeVO";
import {
  ModalDirective,
  TypeaheadMatch,
  BsModalService,
  BsModalRef,
} from "ngx-bootstrap";
import { Observable } from "rxjs";
import { TipoRecapitoAnagrafeEnum } from "@app/shared/enum/tipo-recapito-anagrafe-enum";
import { CartaceoVO } from "@app/shared/vo/gescor/cartaceoVO";
import { CreaRecapitoVO } from "@app/shared/vo/gescor/crea-recapitoVO";
import { AnagrafeService } from "@app/shared/services/anagrafe.service";
import "rxjs/add/operator/mergeMap";
@Component({
  selector: "app-modale-soggetti-alternativi",
  templateUrl: "./modale-soggetti-alternativi.component.html",
})
export class ModaleSoggettiAlternativiComponent implements OnInit {
  @Input()
  public rows: EntitaAnagrafeVO[];
  @Output()
  public recapito = new EventEmitter<EntitaAnagrafeVO>();
  public modalRef: BsModalRef;
  public messages = {
    emptyMessage: "Nessun risultato",
    totalMessage: "in totale",
  };
  public ricerca: boolean = true;
  public creaRecapitoCartaceo = new CreaRecapitoVO();
  public soggettoSelezionato: EntitaAnagrafeVO;

  @ViewChild("templateModaleSoggettiAlternativi", { static: false })
  public modaleSogettiAlternativi: ModalDirective;
  asyncSelected: string;
  typeaheadLoading: boolean;
  typeaheadNoResults: boolean;
  dataSource: Observable<any>;
  private config = {
    class: "modal-dialog modal-info modal-lg",
    animated: true,
  };
  inCreazione: boolean = false;
  constructor(
    private cdRef: ChangeDetectorRef,
    private modalService: BsModalService,
    private anagrafeService: AnagrafeService
  ) { }

  ngOnInit() {
    this.inCreazione = false;
    this.creaRecapitoCartaceo = new CreaRecapitoVO();
    this.creaRecapitoCartaceo.cartaceo = new CartaceoVO();
    this.creaRecapitoCartaceo.cartaceo.dug = "";
    this.creaRecapitoCartaceo.cartaceo.indirizzo = "";
    this.creaRecapitoCartaceo.cartaceo.numeroCivico = "";
    this.creaRecapitoCartaceo.cartaceo.comune = "";
    this.creaRecapitoCartaceo.cartaceo.codiceIstat = "";
    this.creaRecapitoCartaceo.cartaceo.provincia = "";
    this.creaRecapitoCartaceo.cartaceo.esteroCitta = "";
    this.creaRecapitoCartaceo.cartaceo.esteroProvincia = "";
    this.creaRecapitoCartaceo.cartaceo.nazione = "Italia";
    this.creaRecapitoCartaceo.cartaceo.cap = "";
    this.dataSource = Observable.create((observer: any) => {
      observer.next(this.asyncSelected);
    }).mergeMap((token: string) => this.anagrafeService.ricercaComune(token));
  }

  public changeTypeaheadLoading(e: boolean): void {
    console.log("changeTypeaheadLoading: ", e);
    this.typeaheadLoading = e;
  }

  public openModal() {
    this.inCreazione = false;
    this.modalRef = this.modalService.show(
      this.modaleSogettiAlternativi,
      this.config
    );
  }

  public typeaheadOnSelect(e: TypeaheadMatch): void {
    this.creaRecapitoCartaceo.cartaceo.comune = e.item.nome;
    this.creaRecapitoCartaceo.cartaceo.codiceIstat = e.item.codiceIstat;
    this.creaRecapitoCartaceo.cartaceo.provincia = e.item.provincia;
    this.creaRecapitoCartaceo.cartaceo.cap = e.item.cap;
  }

  handler(type: string, $event: ModalDirective) {
    // FIX scandaloso per non far apparire la tabella schiacciata
    const tempo = Object.assign([], this.rows);
    this.rows = [...tempo];
    this.cdRef.detectChanges();
  }

  public vaiAFormRecapito(row: EntitaAnagrafeVO) {
    this.soggettoSelezionato = row;
    this.ricerca = false;
  }

  public creaRecapitoAction() {
    this.inCreazione = true;
    this.anagrafeService
      .creaRecapito(
        this.soggettoSelezionato.idSoggetto,
        this.creaRecapitoCartaceo
      )
      .subscribe((response: EntitaAnagrafeVO) => {
        console.log("[creaRecapito] response: ", response);
        response.tipoSoggetto = this.soggettoSelezionato.tipoSoggetto;
        response.denominazioneSoggetto = this.soggettoSelezionato.denominazioneSoggetto;
        response.denominazioneRecapito =
          this.creaRecapitoCartaceo.cartaceo.dug +
          this.creaRecapitoCartaceo.cartaceo.indirizzo;
        response.tipoRecapito = TipoRecapitoAnagrafeEnum.CARTACEO;
        this.recapito.emit(response);
        this.hideModal();
        this.resetLista();
        this.inCreazione = false;
      });
  }

  public tornaALista() {
    this.soggettoSelezionato = null;
    this.creaRecapitoCartaceo = new CreaRecapitoVO();
    this.creaRecapitoCartaceo.cartaceo = new CartaceoVO();
    this.creaRecapitoCartaceo.cartaceo.dug = "";
    this.creaRecapitoCartaceo.cartaceo.indirizzo = "";
    this.creaRecapitoCartaceo.cartaceo.numeroCivico = "";
    this.creaRecapitoCartaceo.cartaceo.comune = "";
    this.creaRecapitoCartaceo.cartaceo.codiceIstat = "";
    this.creaRecapitoCartaceo.cartaceo.provincia = "";
    this.creaRecapitoCartaceo.cartaceo.esteroCitta = "";
    this.creaRecapitoCartaceo.cartaceo.esteroProvincia = "";
    this.creaRecapitoCartaceo.cartaceo.cap = "";
    this.creaRecapitoCartaceo.cartaceo.nazione = "Italia";
    this.ricerca = true;
  }

  public isRecapitoValido(): boolean {
    console.log("isRecapitoValido", this.creaRecapitoCartaceo.cartaceo);
    let isValido = false;
    if (this.creaRecapitoCartaceo.cartaceo.nazione === "Italia") {
      isValido =
        this.creaRecapitoCartaceo.cartaceo.cap.length > 0 &&
        this.creaRecapitoCartaceo.cartaceo.provincia.length > 0 &&
        this.creaRecapitoCartaceo.cartaceo.numeroCivico.length > 0 &&
        this.creaRecapitoCartaceo.cartaceo.nazione.length > 0 &&
        this.creaRecapitoCartaceo.cartaceo.indirizzo.length > 0 &&
        this.creaRecapitoCartaceo.cartaceo.dug.length > 0 &&
        this.creaRecapitoCartaceo.cartaceo.comune.length > 0;
    } else {
      isValido =
        this.creaRecapitoCartaceo.cartaceo.cap.length > 0 &&
        this.creaRecapitoCartaceo.cartaceo.numeroCivico.length > 0 &&
        this.creaRecapitoCartaceo.cartaceo.nazione.length > 0 &&
        this.creaRecapitoCartaceo.cartaceo.indirizzo.length > 0 &&
        this.creaRecapitoCartaceo.cartaceo.dug.length > 0 &&
        this.creaRecapitoCartaceo.cartaceo.esteroCitta.length > 0;
    }

    return isValido;
  }

  public hideModal() {
    this.tornaALista();
    this.modalRef.hide();
  }

  private resetLista() {
    this.rows = [];
  }
}
